import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { FaqList } from "@/components/FaqList";
import { CtaBand } from "@/components/CtaBand";
import { PageHeader } from "@/pages/ContentPage";
import { FAQ_GROUPS } from "@/content/pages";
import { breadcrumbLd, faqLd } from "@/lib/seo";

export default function Faq() {
  const crumbs = [{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq/" }];
  return (
    <>
      <Seo title="FAQ | Ordering, Delivery & Products | SHADC Dispensary Washington, DC"
        description="Answers to common questions about ordering cannabis from SHADC Dispensary: age requirements, delivery area, hours, minimums, products and policies."
        path="/faq/" jsonLd={[breadcrumbLd(crumbs), faqLd(FAQ_GROUPS.flatMap((g) => g.faqs))]} />
      <PageHeader crumbs={crumbs} eyebrow="Help" h1="Frequently Asked Questions" intro="Quick answers about ordering, delivery, products and our store. Can't find what you need? Contact us." />
      <div className="container-x grid gap-12 py-14 lg:grid-cols-[220px_1fr]">
        <nav aria-label="FAQ sections" className="hidden lg:block">
          <ul className="sticky top-28 space-y-2">{FAQ_GROUPS.map((g) => <li key={g.title}><a href={`#faq-${g.title.toLowerCase()}`} className="text-gray-400 hover:text-gold">{g.title}</a></li>)}</ul>
        </nav>
        <div className="space-y-12">
          {FAQ_GROUPS.map((g) => (
            <section key={g.title} id={`faq-${g.title.toLowerCase()}`} aria-labelledby={`h-${g.title}`} className="scroll-mt-28">
              <h2 id={`h-${g.title}`} className="mb-5 text-2xl font-semibold text-white">{g.title}</h2>
              <FaqList faqs={g.faqs} id={`faq-${g.title.toLowerCase()}`} />
            </section>
          ))}
          <p className="text-gray-400">Still have questions? <Link to="/contact/" className="link-gold">Contact us</Link> or read <Link to="/how-to-order/" className="link-gold">how to order</Link>.</p>
        </div>
      </div>
      <CtaBand />
    </>
  );
}
